module.exports = __webpack_public_path__ + "static/media/Location_Book-Page21.c55b3a49.png";